import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { EHooksVersions } from "app/services/SwHook";
import { allTrackers } from "app/services/track/track";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const getFooterButtonConfig = (params: Record<string, unknown>) => [
    {
        type: buttonTypes.FLAT,
        text: translate("website.analysis.search.overview.top.paid.landing.pages.footer.btn.see.all"),
        link: proNavigator.href("organicsearch_website_landingpages_v2", params),
        onClick: () => allTrackers.dispatchTrackEvent("Internal Link", "click", "Performance/Top paid landing pages"),
        unlockHook: {
            component: "OrganicLandingPagesV2",
            hookModal: "keywordResearch",
            version: isNoTouch(swSettings) ? EHooksVersions.V6 : EHooksVersions.V5,
        },
    },
];

export const switcherConfigItems = [
    {
        title: "website.analysis.search.overview.top.paid.landing.pages.switcher.top",
        value: "top",
        landingPagesChangeFilter: "",
    },
    {
        title: "website.analysis.search.overview.top.paid.landing.pages.switcher.trending",
        value: "trending",
        landingPagesChangeFilter: "Trending",
    },
    {
        title: "website.analysis.search.overview.top.paid.landing.pages.switcher.new",
        value: "new",
        landingPagesChangeFilter: "New",
    },
];
